import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ArrowBack, ArrowForward, Delete, History } from "@mui/icons-material";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import CustomTextField from "../CustomComponents/CustomTextField";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import StlapFooter from "../CustomComponents/StlapFooter";
import CustomButton from "../CustomComponents/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import CustomDateField from "../CustomComponents/CustomDateField";
import axios from "axios";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import CustomSnackBar from "../CustomComponents/CustomSnackBar";
import { GridEditInputCell } from "@mui/x-data-grid";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import dayjs from "dayjs";
import { useRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import store from "../Store";

const PrePaymentHandling = () => {
  const [effectiveDate, setEffectiveDate] = useState("");
  const [prevEffectiveDate, setPrevEffectiveDate] = useState("");
  const [isClear, setIsClear] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("range missmatch");
  const [addRowSnackBarShow, setAddRowSnackBarShow] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [prepayRecordsOverviewGridRows, setPrepayRecordsOverviewGridRows] =
    useState([]);
  const [
    prepayRecordsOverviewGridColumns,
    setPrepayRecordsOverviewGridColumns,
  ] = useState([]);
  const [prepayRecordsOverviewDlg, setPrepayRecordsOverviewDlg] =
    useState(false);
  const [datarows, setDatarows] = useState([]);
  const [modifiedMaps, setModifiedmap] = React.useState({});
  //Validation Dialog State
  const [validationDialog, setValidationDialog] = useState(false);
  // max value 1200 -> mobile.
  // const [voucherDateError, setVoucherDateError] = useState(false);
  const [emptyValueFlag, setEmptyValueFlag] = useState(false);
  const [duplicateFlag, setDuplicateFlag] = useState(false);
  const [discardDialogOpen, setDiscardDialogOpen] = useState(false);
  const [discardDateValue, setDiscardDateValue] = useState("");
  const userName = useSelector((state) => state.branch.userName);
  const [prepaymentReason, setPrepaymentReason] = useState([]);
  const [customerTypes, setCustomerTypes] = useState([]);
  const [voucherValidDateError, setVoucherValidDateError] = useState(false);
  const [dueValidDateError, setDueValidDateError] = useState(false);
  const dispatch = useDispatch();
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);
  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);
  let flag;
  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let minDateFromValue = Number(0);
  let maxDateFromValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["PrePayment Request Date Back Count"] &&
        new Date(
          paramValues["PrePayment Request Date Back Count"]["paramEffStartDate"]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["PrePayment Request Date Back Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateFromValue = 0;
    } else {
      minDateFromValue =
        fieldAccessMap.prePaymentHandlingEffectiveDate &&
        fieldAccessMap.prePaymentBackCount
          ? Number(
              paramValues["PrePayment Request Date Back Count"]["paramValue"]
            )
          : Number(0);
    }
    if (
      !(
        paramValues["PrePayment Request Date Future Count"] &&
        new Date(
          paramValues["PrePayment Request Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["PrePayment Request Date Future Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateFromValue = 0;
    } else {
      maxDateFromValue =
        fieldAccessMap.prePaymentHandlingEffectiveDate &&
        fieldAccessMap.prePaymentFutureCount
          ? Number(
              paramValues["PrePayment Request Date Future Count"]["paramValue"]
            )
          : Number(0);
    }
  }
  //Effective date handler

  const [effectiveDateIsTouched, setEffectiveDateIsTouched] = useState(false);
  const effectiveDateIsValid =
    new Date(effectiveDate).toDateString() !== "Invalid Date" &&
    effectiveDate !== null &&
    new Date(effectiveDate).toLocaleDateString().slice(-4) >= "1970" &&
    new Date(effectiveDate).toLocaleDateString().slice(-4) <= "2055";
  const effectiveDateHasError = effectiveDateIsTouched && !effectiveDateIsValid;
  const effectiveDateEmpty =
    effectiveDateIsTouched && (effectiveDate === "" || effectiveDate === null);
  //shortcut key

  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);
  const saveRef = useRef(null);
  const addRowRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "prePaymenthandling",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      clearRef: clearRef,
      searchButtonRef: searchButtonRef,
      saveRef: saveRef,
      addRowRef: addRowRef,
    };
    if (event.ctrlKey) {
      if (charCode === "i") {
        setEffectiveDate(date);
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        setEffectiveDate(date);
      } else if (charCode === "p") {
        date.setDate(date.getDate() - 1);
        setEffectiveDate(date);
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "prePaymenthandling",
          })
        );
      }
    }
  };
  useEffect(() => {
    // Load values from the LOV Master API.
    const getLovMasterData = async () => {
      const prePaymenthandlingLovValues = await axios.post(
        "/lovMaster/getLovValues",
        {
          moduleId: "MD011",
        }
      );
      const lovData = prePaymenthandlingLovValues.data;
      const customerTypesValues = lovData?.["Customer Type"].map(
        (record) => record.lovValues
      );
      setCustomerTypes([...customerTypesValues]);
    };
    getLovMasterData();
    let newRow = {
      id: 0,
      customerType: "",
      product: "",
      rateType: "",
      prepaymentReason: "",
      rate: "",
    };
    let newList = [];
    newList.push(newRow);
    setDatarows(newList);
    setTotalPageCount(
      datarows.length % 10 !== 0
        ? Number(Number((datarows.length / 10).toFixed()) + 1)
        : Number(Number((datarows.length / 10).toFixed()))
    );
    setTotalRowsCount(datarows.length);
    setPage(1);
    getPrePaymentReason();
  }, []);
  const getPrePaymentReason = async () => {
    try {
      const response = await axios.post(
        "/prepaymentCharges/getPrePaymentReason",
        { apiCode: "PRE_PAYMENT_REASONS_API", createdBy: userName }
      );
      if (response.data) {
        setPrepaymentReason(response.data);
      }
    } catch {
      console.log("Network Error");
    }
  };
  const handleCellEditDisable = (event) => {
    console.log(event);
  };

  const onSaveButtonClickHandler = async () => {
    let paramMap = {};
    datarows.forEach((map, index) => {
      map["createdBy"] = userName;
      map["effectiveDate"] = effectiveDate.toString();
      map["rate"] = map["rate"].toString();
    });
    paramMap["data"] = datarows;
    paramMap["historyData"] = historyData;
    try {
      const response = await axios.post(
        "/prepaymentCharges/insertPrepaymentCharges",
        paramMap
      );
      if (response.data === "saved") {
        setCashSavedDialogOpen(true);
      } else {
        setCashSavedDialogOpen(false);
      }
    } catch {
      console.log("Network Error");
    }
  };
  const columns = [
    {
      field: "id",
      headerName: "S.No",
      headerAlign: "center",
      align: "left",
      flex: 1,
      editable: false,
      hide: true,
    },
    {
      field: "customerType",
      headerName: "Customer Type",
      headerAlign: "center",
      align: "left",
      flex: 270,
      type: "string",
      editable: true,
      type: "singleSelect",
      valueOptions: customerTypes,
    },
    {
      field: "product",
      headerName: "Product",
      headerAlign: "center",
      align: "left",
      flex: 270,
      type: "string",
      editable: true,

      type: "singleSelect",
      valueOptions: ["ST-LAP"],
    },
    {
      field: "rateType",
      headerName: "Rate Type",
      headerAlign: "center",
      align: "left",
      flex: 270,
      type: "string",
      editable: true,

      type: "singleSelect",
      valueOptions: ["Fixed", "Variable", "Fixed With Reset"],
    },
    {
      field: "prepaymentReason",
      headerName: "Pre Payment Reason",
      headerAlign: "center",
      align: "left",
      flex: 270,
      type: "string",
      editable: true,
      type: "singleSelect",
      valueOptions: prepaymentReason,
    },
    {
      field: "rate",
      headerName: "Pre Payment %",
      headerAlign: "center",
      align: "right",
      flex: 160,
      type: "number",
      editable: true,

      valueGetter: (value) => {
        if (
          Math.sign(Number(value.value)) !== -1 &&
          Number(value.value) >= 0 &&
          Number(value.value) &&
          Number(value.value) <= 99.99
        ) {
          setShowSnackBar(false);
          return Number(value.value).toFixed(2);
        } else {
          return 0.0;
        }
      },
    },

    {
      field: "icon",
      headerName: "",
      headerAlign: "center",
      align: "left",
      flex: 25,
      type: "number",
      editable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Tooltip title="Delete">
            <Delete
              onClick={() => {
                deleteSelectedRow(params);
              }}
            ></Delete>
          </Tooltip>
        );
      },
    },
  ];

  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  //Button updation
  //Button state to show or Hide
  const [enableAddButton, setEnableAddButton] = useState(true);
  const [gridVisible, setGridVisible] = useState(false);
  const [savedDialogOpen, setSaveDialogOpen] = useState(false);
  const [cashSavedDialogOpen, setCashSavedDialogOpen] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [historyData, setHistoryData] = useState({});
  const handleSearch = () => {
    if (!saveDisabled) {
      setDiscardDialogOpen(true);
    } else {
      setEffectiveDateIsTouched(true);
      if (effectiveDateIsValid) {
        getSavedData();
      }
    }
  };
  const getModifiedData = (modifiedData) => {
    let modifiedMap = {};
    modifiedData.forEach(function (key) {
      modifiedMap[key["id"]] =
        key["customerType"] +
        key["product"] +
        key["rateType"] +
        key["prepaymentReason"] +
        key["rate"];
    });
    return modifiedMap;
  };

  const getSavedData = async () => {
    try {
      const response = await axios.post(
        "/prepaymentCharges/getByEffectiveDate",
        effectiveDate
      );
      if (response.data) {
        setDatarows(response.data);
        setPage(0);
        setModifiedmap(getModifiedData(response.data));
      }
    } catch {
      console.log("Network Error");
    }
    setGridVisible(true);
  };

  const clearButtonClickHandler = () => {
    if (!saveDisabled) {
      setIsClear(true);
      setDiscardDialogOpen(true);
    } else {
      setEffectiveDateIsTouched(false);
      setGridVisible(false);
      let newRow = {
        id: 0,
        customerType: "",
        product: "",
        rateType: "",
        prepaymentReason: "",
        rate: "",
      };
      let newList = [];
      newList.push(newRow);
      setEffectiveDate(null);
      setDatarows(newList);
      setVoucherValidDateError(false);
    }
  };

  const onHistoryPreviewBtnClick = async () => {
    let previewColumns = [];
    previewColumns.push({
      field: "effectiveDate",
      headerName: "Effective Date",
      headerAlign: "center",
      align: "left",
      flex: 270,
      editable: false,
      filterable: false,
    });
    const filteredColumns = columns.filter(
      (col) => col.field !== "id" && col.field !== "icon"
    );
    previewColumns = previewColumns.concat(filteredColumns);
    previewColumns = previewColumns.map((col) => {
      col.editable = false;
      col.filterable = false;
      return col;
    });
    setPrepayRecordsOverviewGridColumns(previewColumns);
    const response = await axios.post(
      "/prepaymentCharges/findAllPrePaymentChargesList"
    );
    let records = response.data;
    records = records.map((record, index) => {
      record.id = index;
      record.effectiveDate = dayjs(new Date(record.effectiveDate)).format(
        "DD/MM/YYYY"
      );
      return record;
    });
    setPrepayRecordsOverviewGridRows(records);
    setTimeout(() => {
      setPrepayRecordsOverviewDlg(true);
    }, 500);
  };

  //save action
  const valiateTosave = () => {
    let rateFlag = false;
    datarows.forEach((data) => {
      if (data.rate <= 0) {
        rateFlag = true;
      }
    });
    if (rateFlag) {
      // setSnackBarMessage("Value Should be between 0 to 99.99");
      // setShowSnackBar(true);
      // setValidationDialog(true);
      if (flag) {
        return;
      } else {
        setValidationDialog(true);
      }
      return;
    } else {
      if (doCheckValidation()) {
        setSaveDialogOpen(true);
      } else {
        setErrorDialogOpen(true);
        setSaveDialogOpen(false);
      }
    }
  };
  const isScientificNotation = (value) => {
    const scientificNotationPattern =
      /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)$/;
    return scientificNotationPattern.test(value);
  };
  //validate grid data
  const doCheckValidation = () => {
    var saveFlag = true;
    var duplicateMap = new Set();
    // datarows.forEach((data, index) => {
    //   if (
    //     !duplicateMap.has(
    //       data["product"] +
    //         data["customerType"] +
    //         data["rateType"] +
    //         data["prepaymentReason"]
    //     )
    //   ) {
    //     duplicateMap.add(
    //       data["product"] +
    //         data["customerType"] +
    //         data["rateType"] +
    //         data["prepaymentReason"]
    //     );
    //   } else {
    //     setDuplicateFlag(true);
    //     saveFlag = false;
    //     return;
    //   }
    //   if (
    //     !data["product"] ||
    //     !data["customerType"] ||
    //     !data["rateType"] ||
    //     !data["prepaymentReason"]
    //   ) {
    //     saveFlag = false;
    //     setEmptyValueFlag(true);
    //     return;
    //   }
    // });
    // return saveFlag;
    let result = true;
    datarows.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === "" || obj[key] === undefined || obj[key] === null) {
          result = false;
        }
      });
    });

    if (!result) {
      setEmptyValueFlag(true);
      setDuplicateFlag(false);
      saveFlag = false;
    } else {
      datarows.forEach((data, index) => {
        if (
          !duplicateMap.has(
            data["product"] +
              data["customerType"] +
              data["rateType"] +
              data["prepaymentReason"]
          )
        ) {
          duplicateMap.add(
            data["product"] +
              data["customerType"] +
              data["rateType"] +
              data["prepaymentReason"]
          );
        } else {
          setEmptyValueFlag(false);
          setDuplicateFlag(true);
          saveFlag = false;
        }
      });
    }
    return saveFlag;
  };
  const handleCellChangedEvent = (event) => {
    const idKey = event.id;
    if (event.field === "rate") {
      flag = true;
      setSnackBarMessage("Value Should be between 0 to 99.99");
      setShowSnackBar(true);
      datarows[event.id][event.field] =
        event.value <= 0 || event.value > 99.99 ? 0 : event.value;
      // setHistoryData(...historyData, event.id);
      setHistoryData((previousValue) => {
        return {
          ...previousValue,
          idKey: idKey,
        };
      });

      setDatarows(datarows);
      setSaveDisabled(
        JSON.stringify(modifiedMaps) ===
          JSON.stringify(getModifiedData(datarows))
      );
    } else {
      datarows[event.id][event.field] = event.value;
      // setHistoryData(...historyData, event.id);
      setHistoryData((previousValue) => {
        return {
          ...previousValue,
          idKey: idKey,
        };
      });

      setDatarows(datarows);
      setSaveDisabled(
        JSON.stringify(modifiedMaps) ===
          JSON.stringify(getModifiedData(datarows))
      );
    }
  };
  const onCellKeyDownHandler = (params, event) => {
    const idKey = params.id;
    if (params.field === "rate") {
      // setSnackBarMessage("Value Should be between 0 to 99.99");
      // setShowSnackBar(true);
      datarows[params.id][params.field] =
        event.target.value <= 0 || event.target.value > 99
          ? 0
          : event.target.value;
      // setHistoryData(...historyData, event.id);
      setHistoryData((previousValue) => {
        return {
          ...previousValue,
          idKey: idKey,
        };
      });

      setDatarows(datarows);
      setSaveDisabled(
        JSON.stringify(modifiedMaps) ===
          JSON.stringify(getModifiedData(datarows))
      );
    }
  };
  const discardChange = () => {
    setSaveDisabled(true);
    setGridVisible(false);
    setDiscardDialogOpen(false);
    setDatarows([]);
    isClear ? setEffectiveDate(null) : setEffectiveDateIsTouched(false);
    addNewRow();
  };
  const addNewRow = () => {
    if (datarows.length === 0) {
      var newRow = {
        id: datarows.length,
        customerType: "",
        product: "",
        rateType: "",
        prepaymentReason: "",
        rate: "",
      };
      setDatarows((prevRows) => [...prevRows, newRow]);
    } else {
      if (
        datarows[datarows.length - 1]["product"].toString() &&
        datarows[datarows.length - 1]["customerType"].toString() &&
        datarows[datarows.length - 1]["rateType"].toString() &&
        datarows[datarows.length - 1]["prepaymentReason"].toString()
      ) {
        var newRow = {
          id: datarows.length,
          customerType: "",
          product: "",
          rateType: "",
          prepaymentReason: "",
          rate: "",
        };
        setDatarows((prevRows) => [...prevRows, newRow]);
      } else {
        setAddRowSnackBarShow(true);
      }
    }
  };

  const deleteSelectedRow = (param) => {
    var newRows = datarows.filter((row) => row.id !== param.id);
    const updateRecord = newRows.map((record) => {
      if (record.id > param.id) {
        return {
          ...record,
          id: record.id - 1,
        };
      } else {
        return {
          ...record,
        };
      }
    });
    setDatarows(updateRecord);
    setSaveDisabled(newRows.length === 0);
  };

  // const validateEffectiveDate = (date) => {
  //   new Date(date).toDateString() !== "Invalid Date" &&
  //   date !== null &&
  //   new Date(date).toLocaleDateString().slice(-4) >= "1970" &&
  //   new Date(date).toLocaleDateString().slice(-4) <= "2055"
  //     ? setVoucherValidDateError(false)
  //     : setVoucherValidDateError(true);
  // };
  const saveDialogCloseAction = (event) => {
    if (event.key) {
      if (event.key === "Escape" || event.keyCode === 27) {
        setSaveDialogOpen(false);
      }
    } else {
      if (event.currentTarget.type && event.currentTarget.type === "button") {
        setSaveDialogOpen(false);
      } else {
        setSaveDialogOpen(true);
      }
    }
  };
  const successDialogCloseAction = (event) => {
    if (event.key) {
      if (event.key === "Escape" || event.keyCode === 27) {
        setCashSavedDialogOpen(false);
        setSaveDialogOpen(false);
      }
    }
  };
  const errorDialogCloseAction = (event) => {
    if (event.key) {
      if (event.key === "Escape" || event.keyCode === 27) {
        setErrorDialogOpen(false);
        setDuplicateFlag(false);
        setEmptyValueFlag(false);
        setSaveDialogOpen(false);
      }
    }
  };
  const closeDialogAction = (event) => {
    if (event.key) {
      if (event.key === "Escape" || event.keyCode === 27) {
        setDiscardDialogOpen(false);
        setEffectiveDate(prevEffectiveDate);
        setDueValidDateError(false);
        // validateEffectiveDate(prevEffectiveDate);
      }
    } else {
      if (event.currentTarget.type && event.currentTarget.type === "button") {
        setDiscardDialogOpen(false);
        setEffectiveDate(prevEffectiveDate);
        setDueValidDateError(false);

        // validateEffectiveDate(prevEffectiveDate);
      } else {
        setDiscardDialogOpen(true);
      }
    }
  };
  return (
    <>
      <div style={{ minHeight: "calc(100vh - 120px)" }}>
        <Grid
          container
          spacing={2}
          // columns={{ xs: 1, sm: 2, md: 3, lg: 6, xl: 6 }}
          sx={{
            width: "calc(100% - 8px)",
            margin: "unset",
          }}
        >
          <AccordianContainer
            id="accord-jv"
            title="Pre Payment Handling"
            initialOpen={true}
          >
            <Box id="accord-box-jv-create" component="form" validate="true">
              <Grid item container spacing={1}>
                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                ></Grid>

                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                >
                  <CustomDateField
                    required={true}
                    label="Effective Date"
                    id="effectiveDate"
                    disablePast={false}
                    variant="standard"
                    value={effectiveDate}
                    type="text"
                    minDate={new Date().setDate(
                      new Date().getDate() - minDateFromValue
                    )}
                    maxDate={new Date().setDate(
                      new Date().getDate() + maxDateFromValue
                    )}
                    placeholder="Voucher Date"
                    onChange={(event) => {
                      setEffectiveDateIsTouched(true);
                      if (!saveDisabled) {
                        setEffectiveDate(event ? new Date(event) : null);
                        setDiscardDialogOpen(true);
                        setIsClear(false);
                      } else {
                        setEffectiveDate(event ? new Date(event) : null);
                        setEnableAddButton(false);
                        setDatarows([]);
                        setSaveDisabled(true);
                        setGridVisible(false);
                        setPrevEffectiveDate(event ? new Date(event) : null);
                      }
                      const newDateValue = `${new Date(event).getFullYear()}/${
                        new Date(event).getMonth() + 1 > 9
                          ? new Date(event).getMonth() + 1
                          : "0" + new Date(event).getMonth() + 1
                      }/${
                        new Date(event).getDate() > 9
                          ? new Date(event).getDate()
                          : "0" + new Date(event).getDate()
                      }`;
                      const maxValue = new Date().setDate(
                        new Date().getDate() + maxDateFromValue
                      );
                      const maxDateValue = `${new Date(
                        maxValue
                      ).getFullYear()}/${
                        new Date(maxValue).getMonth() + 1 > 9
                          ? new Date(maxValue).getMonth() + 1
                          : "0" + new Date(maxValue).getMonth() + 1
                      }/${
                        new Date(maxValue).getDate() > 9
                          ? new Date(maxValue).getDate()
                          : "0" + new Date(maxValue).getDate()
                      }`;
                      const minValue = new Date().setDate(
                        new Date().getDate() - minDateFromValue
                      );
                      const minDateValue = `${new Date(
                        minValue
                      ).getFullYear()}/${
                        new Date(minValue).getMonth() + 1 > 9
                          ? new Date(minValue).getMonth() + 1
                          : "0" + new Date(minValue).getMonth() + 1
                      }/${
                        new Date(minValue).getDate() > 9
                          ? new Date(minValue).getDate()
                          : "0" + new Date(minValue).getDate()
                      }`;
                      const specialAccessMaxFlag = newDateValue <= maxDateValue;
                      const specialAccessMinFlag = newDateValue >= minDateValue;
                      specialAccessMaxFlag && specialAccessMinFlag
                        ? setDueValidDateError(false)
                        : setDueValidDateError(true);
                    }}
                    onBlur={() => {
                      setEffectiveDateIsTouched(true);
                    }}
                  />

                  {effectiveDateEmpty ? (
                    <p className="error">Please Select effective Date</p>
                  ) : effectiveDateHasError ? (
                    <p className="error">Please Enter Valid effective Datess</p>
                  ) : (
                    dueValidDateError && (
                      <p className="error">Please Enter Valid effective Date</p>
                    )
                  )}
                </Grid>

                <Grid
                  id="grid-container"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={3}
                  xl={3}
                >
                  <Box
                    sx={{
                      margin: "32px 4px 0px 4px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Tooltip title="Ctrl+F" placement="top">
                      <Button
                        sx={{
                          fontWeight: "bold",
                          cursor: "pointer",
                          height: "2rem",
                        }}
                        variant="contained"
                        onClick={(event) => handleSearch(event)}
                        ref={searchButtonRef}
                      >
                        Go
                      </Button>
                    </Tooltip>
                    <Tooltip title="Ctrl+D" placement="top">
                      <Button
                        sx={{
                          marginLeft: "8px",
                          color: "white",
                          backgroundColor: "black",
                          fontWeight: "bold",
                          cursor: "pointer",
                          height: "2rem",
                        }}
                        onMouseOver={({ target }) => {
                          target.style.backgroundColor = "black";
                          target.style.color = "white";
                        }}
                        variant="contained"
                        onClick={() => clearButtonClickHandler()}
                        ref={clearRef}
                      >
                        Clear
                      </Button>
                    </Tooltip>
                    <Tooltip title="History" placement="top">
                      <Button
                        sx={{
                          fontWeight: "bold",
                          cursor: "pointer",
                          height: "2rem",
                          marginLeft: "8px",
                        }}
                        variant="contained"
                        onClick={() => onHistoryPreviewBtnClick()}
                      >
                        <History fontSize="small" />
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </AccordianContainer>
          {gridVisible && (
            <AccordianContainer
              id="accord-jv"
              title="Payment Details"
              initialOpen={true}
              sx={{ margin: "8px !important" }}
            >
              <>
                <div
                  style={{
                    direction: "rtl",
                    marginBottom: "4px",
                  }}
                >
                  <Tooltip title="Ctrl+S" placement="top">
                    <CustomButton
                      disabled={saveDisabled}
                      sx={{
                        marginLeft: "8px",
                        color: "white",
                        backgroundColor: "#004a92",
                        fontWeight: "bold",
                        height: "2rem",
                      }}
                      // onMouseOver={({ target }) => {
                      //   target.style.backgroundColor = "#004a92";
                      //   target.style.color = "white";
                      // }}
                      variant="contained"
                      onClick={() => {
                        setTimeout(() => {
                          valiateTosave();
                        }, 1500);
                      }}
                      ref={saveRef}
                    >
                      {"Save"}
                    </CustomButton>
                  </Tooltip>
                  <Tooltip title="Ctrl+A" placement="top">
                    <CustomButton
                      sx={{
                        marginLeft: "1rem",
                        color: "white",
                        backgroundColor: "#004a92",
                        fontWeight: "bold",
                        height: "2rem",
                      }}
                      disabled={enableAddButton}
                      onMouseOver={({ target }) => {
                        target.style.backgroundColor = "#004a92";
                        target.style.color = "white";
                      }}
                      variant="contained"
                      onClick={() => addNewRow()}
                      ref={addRowRef}
                    >
                      +
                    </CustomButton>
                  </Tooltip>
                </div>
                <CustomDataGrid
                  noDataMessage="No Data"
                  noDataOnFilterMessage="No Data on Applied Filter"
                  rows={datarows}
                  columns={columns}
                  rowHeight={40}
                  pageSize={10}
                  pageSizeOptions={[5]}
                  gridLazyLoad={() => {}}
                  gridHeight={
                    datarows.length < 5 && datarows.length !== 0
                      ? datarows.length * 40 + 130
                      : 305
                  }
                  onCellEditCommit={(event) => handleCellChangedEvent(event)}
                  onCellFocusOut={(event) => handleCellEditDisable(event)}
                  onCellKeyDown={(params, event) => {
                    (event.key === "e" || event.key === "E") &&
                      event.preventDefault();
                    onCellKeyDownHandler(params, event);
                  }}
                  isCellEditable={() => {}}
                />
              </>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "18px",
                }}
              ></Box>
            </AccordianContainer>
          )}
        </Grid>
        <CustomConfirmationDialog
          dialogOpen={savedDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={"Save Pre Payment Handling Details ?"}
          hideCancelButton={false}
          okButtonName={"OK"}
          cancelButtonName={"Cancel"}
          onOkClick={() => {
            onSaveButtonClickHandler();
          }}
          onDialogClose={saveDialogCloseAction}
        />{" "}
        <CustomConfirmationDialog
          dialogOpen={discardDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Confirmation</Typography>
          }
          dialogContent={"Are you sure want to discard changes ?"}
          hideCancelButton={false}
          okButtonName={"Yes"}
          cancelButtonName={"Cancel"}
          onOkClick={() => {
            discardChange();
          }}
          onDialogClose={closeDialogAction}
        />
        <CustomConfirmationDialog
          dialogOpen={cashSavedDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
          }
          dialogContent={
            <>
              <Typography sx={{ fontSize: "1rem" }}>
                Pre Payment Handling Charges Saved Successfully.
              </Typography>
            </>
          }
          hideCancelButton={true}
          onDialogClose={successDialogCloseAction}
          okButtonName={"OK"}
          cancelButtonName={""}
          onOkClick={() => window.location.reload()}
        />
        <CustomConfirmationDialog
          dialogOpen={errorDialogOpen}
          dialogTitle={
            <Typography sx={{ fontSize: "1.25rem" }}>Error</Typography>
          }
          dialogContent={
            <>
              {emptyValueFlag && !duplicateFlag && (
                <Typography sx={{ fontSize: "1rem" }}>
                  There are some empty records. Please enter values for all the
                  columns in the table.
                </Typography>
              )}
              {duplicateFlag && (
                <Typography sx={{ fontSize: "1rem" }}>
                  There are some duplicate record in the table
                </Typography>
              )}
            </>
          }
          hideCancelButton={true}
          okButtonName={"OK"}
          cancelButtonName={""}
          onDialogClose={errorDialogCloseAction}
          onOkClick={() => {
            setDuplicateFlag(false);
            setEmptyValueFlag(false);
            setErrorDialogOpen(false);
          }}
        />
      </div>
      <Dialog open={validationDialog}>
        <DialogTitle>
          <h4>Information</h4>
        </DialogTitle>
        <DialogContent>Value Should be between 0 to 99.99</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setValidationDialog(false);
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={prepayRecordsOverviewDlg} fullScreen>
        <DialogTitle>
          <h4>Prepay Records Overview</h4>
        </DialogTitle>
        <DialogContent>
          <CustomDataGrid
            noDataMessage="No Data"
            noDataOnFilterMessage="No Data on Applied Filter"
            rows={prepayRecordsOverviewGridRows}
            columns={prepayRecordsOverviewGridColumns}
            rowHeight={40}
            pageSize={10}
            pageSizeOptions={[5]}
            gridLazyLoad={() => {}}
            isCellEditable={() => {}}
            gridHeight={window.innerHeight - 200}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setPrepayRecordsOverviewDlg(false);
            }}
          >
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>
      <CustomSnackBar
        showSnackbar={showSnackBar}
        autoHideDuration={5000}
        onClose={() => {
          setShowSnackBar(false);
          flag = false;
        }}
        message={snackBarMessage}
        severity="error"
      />
      <CustomSnackBar
        showSnackbar={addRowSnackBarShow}
        autoHideDuration={5000}
        onClose={() => {
          setAddRowSnackBarShow(false);
        }}
        message={"Please Enter all fileld value"}
        severity="warning"
        color={"red"}
      />
      <StlapFooter />
      {/* <JvHistory open={historyOpen}></JvHistory> */}
    </>
  );
};
export default PrePaymentHandling;
